/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */
import React from 'react';
import {
    object, string, func, oneOfType, shape, elementType, number,
} from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import CustomsCardWrapper from '../CustomsCardWrapper/CustomsCardWrapper';
import ImageEditor from './ImageEditor/ImageEditor';
import SelectPersonalizeImage from './ImageEditor/SelectPersonalizeImage';

const styles = () => ({
    selectCustomsContainer: {
        margin: '30px 0px',
        display: 'flex',
        justifyContent: 'center',
    },
    selectedImage: {
        width: '100%',
        height: '100%',
    },
});
const PersonalizeImageCustoms = ({
    customsCard, classes, image,  handleImage, imagePreviewCanvasRef, setImage, imgHeight, imgWidth, dataDictionary,
}) => (
    <Grid item sm={12} className={classes.selectCustomsContainer}>
        <CustomsCardWrapper customsCard={customsCard}>
            {!image
                ?                    (
                    <SelectPersonalizeImage handleImage={handleImage} dataDictionary={dataDictionary} />
                )
                : (
                    <ImageEditor
                        image64={image}
                        setImage={setImage}
                        imgWidth={imgWidth}
                        imgHeight={imgHeight}
                        imagePreviewCanvasRef={imagePreviewCanvasRef}
                    />
                )}
        </CustomsCardWrapper>
    </Grid>
);

PersonalizeImageCustoms.propTypes = {
    classes: object.isRequired,
    customsCard: string.isRequired,
    image: string.isRequired,
    handleImage: func.isRequired,
    setImage: func.isRequired,
    imagePreviewCanvasRef: oneOfType([
        func,
        shape({ current: elementType }),
    ]).isRequired,
    imgWidth: number.isRequired,
    imgHeight: number.isRequired,
    dataDictionary: object,
};

PersonalizeImageCustoms.defaultProps = {
    dataDictionary: {},
};
export default withStyles(styles)(PersonalizeImageCustoms);
